import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DesignApi } from '../../services/designService';
import { ClientSideEndpoints } from '../../services/clientDetailService';

export const fetchProductDetailForDesign = createAsyncThunk(

    'design/fetchProductDetailForDesign',
    async (subCategoryId, { rejectWithValue }) => {
        try {
            const response = await DesignApi.fetchProductDetailForDesign(subCategoryId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const saveUserCustomizeProductDesign = createAsyncThunk(
    'design/saveUserCustomizeProductDesign',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DesignApi.saveUserCustomizeProductDesign(data);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const fetchUserCustomizeProductDesign = createAsyncThunk(
    'design/fetchUserCustomizeProductDesign',
    async (projectId, { rejectWithValue }) => {
        try {
            const response = await DesignApi.fetchUserCustomizeProductDesign(projectId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const updateCustomizeProductDesign = createAsyncThunk(
    'design/updateCustomizeProductDesign',
    async ({ projectId, data }, { rejectWithValue }) => {
        try {
            const response = await DesignApi.updateCustomizeProductDesign(projectId, data);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const getAllCustomerCustomizedDesign = createAsyncThunk(
    'design/getAllCustomerCustomizedDesign',
    async (_, { rejectWithValue }) => {
        try {
            const response = await DesignApi.getAllCustomerCustomizedDesign();
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const searchAndFilterUserCustomizedDesign = createAsyncThunk(
    'design/searchAndFilterUserCustomizedDesign',
    async ({ searchTerm, filterParams }, { rejectWithValue }) => {
        try {
            const response = await DesignApi.searchAndFilterUserCustomizedDesign(searchTerm, filterParams);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    });

export const deleteUserCustomizedDesign = createAsyncThunk(
    'design/deleteUserCustomizedDesign',
    async (projectId, { rejectWithValue }) => {
        try {
            const response = await DesignApi.deleteUserCustomizedDesign(projectId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const addToProductOrProjectToFavorites = createAsyncThunk(
    'product/addToProductOrProjectToFavorites',
    async (formData, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.addToProductOrProjectToFavorites(formData);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const removeProductOrProjectFromFavorites = createAsyncThunk(
    'product/removeProductOrProjectFromFavorites',
    async (itemId, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.removeProductOrProjectFromFavorites(itemId);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const addProductToCart = createAsyncThunk(
    'product/addProductToCart',
    async (formData, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.addProductToCart(formData);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const removeProductFromCart = createAsyncThunk(
    'product/removeProductFromCart',
    async (itemId, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.removeProductFromCart(itemId);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

const designSlice = createSlice({
    name: 'design',
    initialState: {
        productDetails: null,
        userCustomizedProductDesign: null,
        fetchProductDetailLoading: false,
        fetchProductDetailError: null,
        saveUserCustomizeLoading: false,
        saveUserCustomizeError: null,
        fetchUserCustomizeLoading: false,
        fetchUserCustomizeError: null,
        updateCustomizeLoading: false,
        updateCustomizeError: null,
        getAllCustomerCustomizedDesignLoading: false,
        getAllCustomerCustomizedDesignError: null,
        getAllCustomerCustomizedDesignData: null,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // fetchProductDetailForDesign
            .addCase(fetchProductDetailForDesign.pending, (state) => {
                state.fetchProductDetailLoading = true;
                state.fetchProductDetailError = null;
            })
            .addCase(fetchProductDetailForDesign.fulfilled, (state, action) => {
                state.fetchProductDetailLoading = false;
                state.productDetails = action.payload;
            })
            .addCase(fetchProductDetailForDesign.rejected, (state, action) => {
                state.fetchProductDetailLoading = false;
                state.fetchProductDetailError = action.payload;
            })
            // saveUserCustomizeProductDesign
            .addCase(saveUserCustomizeProductDesign.pending, (state) => {
                state.saveUserCustomizeLoading = true;
                state.saveUserCustomizeError = null;
            })
            .addCase(saveUserCustomizeProductDesign.fulfilled, (state, action) => {
                state.saveUserCustomizeLoading = false;
                state.userCustomizedProductDesign = action.payload;
            })
            .addCase(saveUserCustomizeProductDesign.rejected, (state, action) => {
                state.saveUserCustomizeLoading = false;
                state.saveUserCustomizeError = action.payload;
            })
            // fetchUserCustomizeProductDesign
            .addCase(fetchUserCustomizeProductDesign.pending, (state) => {
                state.fetchUserCustomizeLoading = true;
                state.fetchUserCustomizeError = null;
            })
            .addCase(fetchUserCustomizeProductDesign.fulfilled, (state, action) => {
                state.fetchUserCustomizeLoading = false;
                state.userCustomizedProductDesign = action.payload;
            })
            .addCase(fetchUserCustomizeProductDesign.rejected, (state, action) => {
                state.fetchUserCustomizeLoading = false;
                state.fetchUserCustomizeError = action.payload;
            })
            .addCase(updateCustomizeProductDesign.pending, (state) => {
                state.updateCustomizeLoading = true;
                state.updateCustomizeError = null;
            })
            .addCase(updateCustomizeProductDesign.fulfilled, (state, action) => {
                state.updateCustomizeLoading = false;
                state.userCustomizedProductDesign = action.payload;
            })
            .addCase(updateCustomizeProductDesign.rejected, (state, action) => {
                state.updateCustomizeLoading = false;
                state.updateCustomizeError = action.payload;
            })
            // getAllCustomerCustomizedDesign
            .addCase(getAllCustomerCustomizedDesign.pending, (state) => {
                state.getAllCustomerCustomizedDesignLoading = true;
                state.getAllCustomerCustomizedDesignError = null;
            })
            .addCase(getAllCustomerCustomizedDesign.fulfilled, (state, action) => {
                state.getAllCustomerCustomizedDesignLoading = false;
                state.getAllCustomerCustomizedDesignData = action.payload;
            })
            .addCase(getAllCustomerCustomizedDesign.rejected, (state, action) => {
                state.getAllCustomerCustomizedDesignLoading = false;
                state.getAllCustomerCustomizedDesignError = action.payload;
            })
            //filterUserCustomizedDesign
            .addCase(searchAndFilterUserCustomizedDesign.pending, (state) => {
                state.getAllCustomerCustomizedDesignLoading = true;
                state.getAllCustomerCustomizedDesignError = null;
            })
            .addCase(searchAndFilterUserCustomizedDesign.fulfilled, (state, action) => {
                state.getAllCustomerCustomizedDesignLoading = false;
                state.getAllCustomerCustomizedDesignData = action.payload;
            })
            .addCase(searchAndFilterUserCustomizedDesign.rejected, (state, action) => {
                state.getAllCustomerCustomizedDesignLoading = false;
                state.getAllCustomerCustomizedDesignError = action.payload;
            })
            // deleteUserCustomizedDesign
            .addCase(deleteUserCustomizedDesign.pending, (state) => {
                state.getAllCustomerCustomizedDesignLoading = true;
                state.getAllCustomerCustomizedDesignError = null;
            })
            .addCase(deleteUserCustomizedDesign.fulfilled, (state, action) => {
                state.getAllCustomerCustomizedDesignLoading = false;
                state.getAllCustomerCustomizedDesignData = state.getAllCustomerCustomizedDesignData.filter(
                    (design) => design.id !== action.payload.id
                );
            })

            .addCase(addToProductOrProjectToFavorites.fulfilled, (state, action) => {
                if (state.getAllCustomerCustomizedDesignData == null || state.getAllCustomerCustomizedDesignData.length === 0) return;

                state.getAllCustomerCustomizedDesignData = state.getAllCustomerCustomizedDesignData.map((design) => {
                    if (design.id === action.payload.id) {
                        return { ...design, is_favorite: true };
                    }
                    return design;
                });
            })

            .addCase(removeProductOrProjectFromFavorites.fulfilled, (state, action) => {
                if (state.getAllCustomerCustomizedDesignData == null || state.getAllCustomerCustomizedDesignData.length === 0) return;
                state.getAllCustomerCustomizedDesignData = state.getAllCustomerCustomizedDesignData.map((design) => {
                    if (design.id === action.payload.product_id) {
                        return { ...design, is_favorite: false };
                    }
                    return design;
                });
            })

            .addCase(addProductToCart.fulfilled, (state, action) => {
                if (state.getAllCustomerCustomizedDesignData == null || state.getAllCustomerCustomizedDesignData.length === 0) return;
                
                state.getAllCustomerCustomizedDesignData = state.getAllCustomerCustomizedDesignData.map((design) => {
                    if (design.id === action.payload.id) {
                        return { ...design, is_in_cart: true };
                    }
                    return design;
                });
            })

            .addCase(removeProductFromCart.fulfilled, (state, action) => {
                if (state.getAllCustomerCustomizedDesignData == null || state.getAllCustomerCustomizedDesignData.length === 0) return;
                state.getAllCustomerCustomizedDesignData = state.getAllCustomerCustomizedDesignData.map((design) => {
                    if (design.id === action.payload.product_id) {
                        return { ...design, is_in_cart: false };
                    }
                    return design;
                });
            });

    },
});



export default designSlice.reducer;
